/**
 * Created by andermurias on 18/7/17.
 */
/**
 * Created by andermurias on 18/7/17.
 */
import React, {Component} from 'react';

import '../../styles/elements/resumeJobs.css';

class ResumeJobs extends Component {
    render() {
        return (
            <ul className={'resume-jobs' + (this.props.className ? ' ' + this.props.className : '')}>
                {this.props.elements.map((element, i) => {
                    return (
                        <li className="resume-jobs__element" key={'rjobs-' + i}>
                            <div className="resume-jobs__title">{element.title}</div>
                            <div className="resume-jobs__subtitle">
                                <span className="resume-jobs__charge">{element.charge}</span>
                                <span className="resume-jobs__date">{element.date}</span>
                            </div>
                            <div className="resume-jobs__description">{element.description}</div>
                        </li>
                    )
                })}
            </ul>
        )
    }
}

export default ResumeJobs;



// WEBPACK FOOTER //
// ./src/js/elements/ResumeJobs.js